import { useSelector } from 'react-redux'
import { userPreferencesView } from '$logic/user-preferences/storage'

export function usePinnedRoomIdsAndWorkspaces() {
  return useSelector(state => userPreferencesView(state)?.pinnedRooms) || []
}
